import { render } from "./compliance.cattle.io.clusterscan.vue?vue&type=template&id=1606b950&scoped=true"
import script from "./compliance.cattle.io.clusterscan.vue?vue&type=script&lang=js"
export * from "./compliance.cattle.io.clusterscan.vue?vue&type=script&lang=js"

import "./compliance.cattle.io.clusterscan.vue?vue&type=style&index=0&id=1606b950&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1606b950"]])

export default __exports__